/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];

    const NAME = feature.getSettingValue('NAME');
    const SERVO_PERIOD = feature.getSettingValue('SERVO_PERIOD');
    const PIN = feature.getSettingValue('PIN');
    if (!PIN) {
        return blocks;
    }
    const dtsName = `${NAME.toLowerCase()}_servo`;
    const frequency = 50;

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
${dtsName} = machine.PWM(machine.Pin(${PIN}), freq=${frequency}, duty_u16=int(int(${SERVO_PERIOD} * ${frequency} / 1e6  * 65535)))`,
    });

    blocks.push({
        location: `var_${SERVO_PERIOD}_set`,
        blockType: BlockType.CODE,
        template: `
${dtsName}.duty_u16(int(${SERVO_PERIOD} * ${frequency} / 1e6  * 65535))
`,
    });

    return blocks;
};
